import { render, staticRenderFns } from "./ShowcaseCompanyLogo.vue?vue&type=template&id=ddeed664&scoped=true"
import script from "./ShowcaseCompanyLogo.vue?vue&type=script&lang=js"
export * from "./ShowcaseCompanyLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddeed664",
  null
  
)

export default component.exports